<template>
  <v-layout
    id="resetPassword"
    row
    wrap
    justify-center
  >
    <v-flex
      xs12
      sm8
      md6
    >
      <v-card class="elevation-12 register">
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>
            {{ $t('message.reset_password_form_title') }}
          </v-toolbar-title>
          <v-spacer />
          <img src="../../../public/cow.svg">
        </v-toolbar>
        <v-card-text>
          <v-form
            novalidate
            @submit.prevent="validatePassword"
          >
            <v-text-field
              ref="newPassword"
              v-model="user.password"
              required
              name="password"
              :label="($t('message.new_password') + ' *')"
              type="password"
              :error-messages="validationErrors['password']"
            />
            <v-text-field
              ref="confirm_password"
              v-model="user.confirm_password"
              required
              name="confirm_password"
              :label="($t('message.confirm_password') + ' *')"
              type="password"
              :error-messages="validationErrors['confirm_password']"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            flat
            :to="{ name: 'login' }"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            @click="validatePassword"
          >
            {{ $t('message.save_password_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="showError"
        color="error"
        :multi-line="true"
      >
        {{ $t('message.general_form_error') }}
        <v-btn
          dark
          flat
          @click="showError = false"
        >
          {{ $t('message.close') }}
        </v-btn>
      </v-snackbar>
      <v-snackbar
        v-model="showServiceError"
        color="error"
        :multi-line="true"
      >
        {{ serviceError }}
        <v-btn
          dark
          flat
          @click="showError = false"
        >
          {{ $t('message.close') }}
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import feathersClient from '../../feathers-client'

import { mapState } from 'vuex'

export default {
  mixins: [validationMixin],
  data: (vm) => ({
    user: {
      password: '',
      confirm_password: '',
    },
    serviceError: '',
    showError: false,
    showServiceError: false,
  }),
  computed: {
    validationErrors() {
      const v = this.$v.user
      var errors = {
        password: [],
        confirm_password: [],
      }
      if (v.password.$invalid && v.password.$dirty) {
        errors['password'].push(this.$t('message.required_field'))
      }
      if (!v.confirm_password.required && v.confirm_password.$dirty) {
        errors['confirm_password'].push(this.$t('message.required_field'))
      }
      if (!v.confirm_password.sameAsPassword && v.confirm_password.$dirty) {
        errors['confirm_password'].push(this.$t('message.passwords_mismatch'))
      }
      return errors
    },
  },
  methods: {
    validatePassword() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.reset()
      } else {
        this.showError = true
      }
    },
    reset() {
      // feathersClient.
      feathersClient
        .service('password-reset')
        .patch(null, {
          password: this.user.password,
          used: true,
          token: this.$route.params.token,
        })
        .then((res) => {
          if (res === false) {
            this.$store.commit(
              'showSnackbarError',
              'message.reset_password_link_expired'
            )
          } else {
            this.$store.commit(
              'showSnackbarMessage',
              'message.new_password_saved'
            )
          }
          this.$router.replace({ name: 'login' })
        })
    },
  },
  validations: {
    user: {
      password: {
        required,
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
}
</script>

<style>
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}
.v-dialog {
  margin: 0 !important;
}
</style>
